import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'redux-first-history';
import R from 'ramda';

import Register from '_templates/RegisterSection';

export default function RegisterPage() {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);

  useEffect(() => {
    if (auth.isAuthenticated) {
      dispatch(push('/'));
    }
  }, []);

  return (
    <div className="register-page page">
      <Register />
    </div>
  );
}
